module.exports = __webpack_public_path__ + "img/Ad_Red_Restro.53897b23.png";